export const DEFAULT_PARTNER = 'VP'

export const PARTNERS_NAME_REFERENCE = {
  EBT: 'veepee',
  PRV: 'privalia',
  VEX: 'veepee',
  VP: 'veepee'
}
